import { render, staticRenderFns } from "./mudProperties.vue?vue&type=template&id=6f5870c3&scoped=true"
import script from "./mudProperties.vue?vue&type=script&lang=ts"
export * from "./mudProperties.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5870c3",
  null
  
)

export default component.exports